import * as React from "react";
import { useWindowTiles } from "../hooks/useWindowTiles";
import { RndResizeCallback } from "react-rnd";

type ContextValue = ReturnType<typeof useWindowTiles>;

const ctx = React.createContext<ContextValue | undefined>(undefined);

export const WindowTilesProvider: React.FC = (props) => {
	const values = useWindowTiles();

	return <ctx.Provider value={values}>{props.children}</ctx.Provider>;
};

export const useWindowTilesContext = () => {
	const context = React.useContext(ctx);
	if (!context) {
		throw new Error("Please use under WindowTilesProvider!");
	}
	return context;
};

export const useWindowTile = (id: string) => {
	const {
		windowTiles,
		minimizeWindow,
		closeWindow,
		windowResized,
		focusedTileId,
		setWindowToBlur,
		setWindowToFocus,
		MobileWindowResized,
	} = useWindowTilesContext();
	const windowTile = windowTiles.find((tile) => tile.id === id);
	const minimize = () => {
		minimizeWindow(id);
	};

	const close = () => {
		closeWindow(id);
	};

	const onResizeStop: RndResizeCallback = (...props) => windowResized(id, ...props);

	return {
		...windowTile!,
		minimize,
		close,
		onResizeStop,
		focusedTileId,
		setWindowToBlur,
		setWindowToFocus,
		MobileWindowResized,
	};
};
